import { gnosis as viemGnosis } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const gnosis = {
  displayName: 'Gnosis Chain',
  runtime: 'evm',
  viemChain: viemGnosis,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'xdai' },
    qnStreams: {
      networkKey: 'gnosis-mainnet',
    },
    pimlico: { chainSlug: 'gnosis' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
